import { render, staticRenderFns } from "./ConversationIcon.vue?vue&type=template&id=10d5f234&scoped=true"
import script from "./ConversationIcon.vue?vue&type=script&lang=js"
export * from "./ConversationIcon.vue?vue&type=script&lang=js"
import style0 from "./ConversationIcon.vue?vue&type=style&index=0&id=10d5f234&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d5f234",
  null
  
)

export default component.exports